import { IGetState, TCardId, TColorId } from '../../../../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { getCard } from '../../../../../../../../store/model/selectors/getCard';
import {
    getAuthUserAllowColorTagCount
} from '../../../../../../../../store/model/authUser/selectors/getAuthUserAllowColorTagCount';
import { root } from '../../../../../../../../store/constants';
import { SegmentCardEvent, SegmentCardOptions, segmentTrackAction } from '../../../../../../../../middlewares/segment';
import { addFeatureTrigger } from '../../../../../../polls/featurePoll/effects/addFeatureTrigger';
import { ERateFeature } from '../../../../../../../../types/rest/IUserMeta';
import { cardSaveColorTags } from '../../../../../../../../rest/effects/card/card/cardSaveColorTags';
import {
    boardUserMetaAddRecentColorTag
} from '../../../../../../../../rest/effects/board/boardUserMetaAddRecentColorTag';
import { getBoardIdByCardId } from '../../../../../../../../store/model/selectors/getBoardIdByCardId';
import { showSnoozeBlocker } from '../../../../../../base/effects/showSnoozeBlocker';
import {
    SegmentCardColorTagAddSourceValue, SegmentCardColorTagUsedValue,
    SegmentCardType
} from '../../../../../../../../middlewares/segment/trackEntities/cardEvents';
import { getBoardCardColorTags } from '../../../../../../../../store/model/selectors/getBoardCardColorTags';
import { getActiveBoardId } from '../../../../../../../../store/model/selectors/getActiveBoardId';

export const onToggle = (
    cardId: TCardId,
    colorId: TColorId,
    source: SegmentCardColorTagAddSourceValue = SegmentCardColorTagAddSourceValue.INITIAL,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const state = getState();
        const colorIds = [...getCard(state, cardId).colorIds];
        const maxCount = getAuthUserAllowColorTagCount(state);
        const count = colorIds.length;
        const usedColorIds = getBoardCardColorTags(state, getActiveBoardId(state), true).map(color => color.id);
        const sourceValue = source === SegmentCardColorTagAddSourceValue.AFTER_SEARCH
            ? `${source} - ${usedColorIds.includes(colorId) ? SegmentCardColorTagUsedValue.USED : SegmentCardColorTagUsedValue.UNUSED}`
            : source;
        if (colorIds.includes(colorId)) {
            if (
                root.App.controller.allowCounterSnackbarHelper.isShowSnackbar('allowColorTagCount') &&
                count > maxCount
            ) {
                return Promise.resolve(false);
            } else {
                colorIds.splice(colorIds.indexOf(colorId), 1);
                dispatch(segmentTrackAction(SegmentCardEvent.REMOVE_COLOR_TAG, {
                    name: SegmentCardOptions.SOURCE,
                    value: sourceValue
                }, [{
                    name: SegmentCardOptions.COUNT,
                    value: count
                }, {
                    name: SegmentCardOptions.TYPE,
                    value: SegmentCardType.CARD_PREVIEW
                }]));
                dispatch(addFeatureTrigger(ERateFeature.COLOR_TAGS));
                return dispatch(cardSaveColorTags(cardId, colorIds)).then(() => {
                    dispatch(boardUserMetaAddRecentColorTag(getBoardIdByCardId(state, cardId), colorId));
                    return Promise.resolve(true);
                });
            }
        } else {
            if (count >= maxCount) {
                dispatch(showSnoozeBlocker({ allow: 'allowColorTagCount' }));
            } else {
                colorIds.push(colorId);
                dispatch(segmentTrackAction(SegmentCardEvent.ADD_COLOR_TAG, {
                    name: SegmentCardOptions.SOURCE,
                    value: sourceValue
                }, [{
                    name: SegmentCardOptions.COUNT,
                    value: count
                }, {
                    name: SegmentCardOptions.TYPE,
                    value: SegmentCardType.CARD_PREVIEW
                }]));
                dispatch(addFeatureTrigger(ERateFeature.COLOR_TAGS));
                return dispatch(cardSaveColorTags(cardId, colorIds)).then(() => {
                    dispatch(boardUserMetaAddRecentColorTag(getBoardIdByCardId(state, cardId), colorId));
                    return Promise.resolve(true);
                });
            }
        }
    };

    return action;
};
